"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INVITE_TEAM_MEMBER_NUDGE_PAYLOAD_KEY = void 0;
exports.INVITE_TEAM_MEMBER_NUDGE_PAYLOAD_KEY = 'nv-type-team-member-invite-nudge';
//# sourceMappingURL=inviteTeamMemberNudge.js.map